import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { id: Number, folderUrl: String }

  connect() {
    this.element.setAttribute('draggable', 'true')
  }

  dragStart(event) {
    event.dataTransfer.setData('application/x-upload-id', this.idValue)
    event.dataTransfer.setData('application/x-upload-folder-url', this.folderUrlValue)
    event.dataTransfer.effectAllowed = 'move'
    this.element.classList.add('opacity-50')
  }

  dragEnd(event) {
    this.element.classList.remove('opacity-50')
  }
}
